// Filename: uicanvasstageseq.js
// Timestamp: 2018.12.10-10:05:34 (last modified)
// Author(s): bumblehead <chris@bumblehead.com>

import {
  gnnodeChildKeysGet as nodeChildKeysGet
} from '@bumblehead/gani/src/gnnode.js'

import {
  gnnodeosxGet as nodeosxGet
} from '@bumblehead/gani/src/gnnodeos.js'

import gnnodex from '@bumblehead/gani/src/gnnodex.js'

const gnnode_childgetfirst = (gr, node) => (
  gr.get(nodeChildKeysGet(node)[0]))

const isinrange = (start, end, current) => (
  Boolean(start <= current && current <= end))

const onrender = (ss, cfg, gr, nd, ndx, prev, stagecfg, timess_current) => {
  let nodecfg
  const {
    actionnode,
    actionnodeui,
    start,
    end
  } = prev

  if (actionnode) {
    nodecfg = gnnodex.prevget(cfg, actionnode)

    actionnodeui.setvisibility(
      ss, cfg, gr, actionnode, nodecfg,
      stagecfg, isinrange(start, end, timess_current))
  }
}

const addtoscene = (ss, cfg, gr, nd, pg, stagecfg) => {
  const rafcfg = gnnodex.prevget(cfg, nd)
  const actionnode = gnnode_childgetfirst(gr, nd)
  const actionnodeprev = actionnode
    && gnnodex.prevget(cfg, actionnode)

  if (!actionnode)
    return stagecfg

  rafcfg.actionnode = actionnode
  rafcfg.actionnodeui = nodeosxGet(cfg, gr, actionnode)
  // locates nodes previous subject
  rafcfg.actionnodeui.addtoscene(
    ss, cfg, gr, actionnode, actionnodeprev, stagecfg)

  return stagecfg
}

const xonsubj = (ss, cfg, gr, nd, prev, { start, end }) => {
  Object.assign(prev, {
    start: +start,
    end: +end
  })

  return true
}

export default {
  type: 'uicanvasstageseq',
  xonsubj,
  isinrange,
  onrender,
  addtoscene
}
